import PauseAdEventInfoContainer from '@components/atoms/container/pauseAdEventInfoContainer';
import PauseAdEventTitlesContainer from '@components/atoms/container/pauseAdEventTitlesContainer';
import PauseAdEventChannelLogo from '@components/atoms/images/pauseAdEventChannelLogo';
import PauseAdEventEventTitle from '@components/atoms/text/pauseAdEventEventTitle';
import PauseAdEventChannelTitle from '@components/atoms/text/pauseAdEventChannelTitle';
import ProgressBarFill from '@components/atoms/container/progressBarFill';
import PauseAdProgressBarContainer from '@components/atoms/container/pauseAdProgressBarContainer';
import Colors from '@shared/assets/style/default/color';
import Event from '@shared/classes/event';
import { useAppSelector } from '@shared/store/hooks';
import { mediaSelector } from '@shared/store/slices/media.slice';

/**
 * Component that displays event information in the pause ad modal.
 * Shows channel logo, channel title, event title, and progress bar.
 *
 * @param {Object} props - Component props
 * @param {Event} props.event - The event to display information for
 * @returns {JSX.Element} Event info container with logo, titles, and progress
 */
function PauseAdEventInfo({ asset }: { asset: Event }) {
  const { progressPercentage } = useAppSelector(mediaSelector);
  return (
    <PauseAdEventInfoContainer>
      <PauseAdEventChannelLogo
        src={asset?.channel?.logoWhite}
      ></PauseAdEventChannelLogo>
      <PauseAdEventTitlesContainer>
        <PauseAdEventChannelTitle>
          {asset?.channel?.title}
        </PauseAdEventChannelTitle>
        <PauseAdEventEventTitle>{asset?.title}</PauseAdEventEventTitle>
      </PauseAdEventTitlesContainer>
      <PauseAdProgressBarContainer>
        <ProgressBarFill
          value={progressPercentage}
          customColor={Colors.progress.ad}
        ></ProgressBarFill>
      </PauseAdProgressBarContainer>
    </PauseAdEventInfoContainer>
  );
}

export default PauseAdEventInfo;
